import { Button } from "@themes/pollinator/ui/Button";
import { useCreateOrganizationInvitation } from "@core/features/organization";
import { INVITATION_TYPE } from "@core/features/invitation";

export type Props = {
  organizationId: number;
  programId: number | null;
  templateId: number | null;
};

/**
 * Button to create an orgAdmin invitation for the organization.
 * Used when no coworker invitation exists yet.
 */
export function CoworkersCreateInvitation({
  organizationId,
  programId,
  templateId,
}: Props) {
  const { mutate: createInvitation, isPending } =
    useCreateOrganizationInvitation({ organizationId });

  const handleCreate = () => {
    if (!programId || !templateId) return;
    createInvitation({
      programId,
      templateId,
      type: INVITATION_TYPE.ORG_ADMIN,
    });
  };

  return (
    <div>
      <Button
        onClick={handleCreate}
        disabled={isPending || !programId || !templateId}
      >
        {isPending ? "Creating..." : "Create Team Invitation"}
      </Button>
    </div>
  );
}
